const CONFIG = {
    title: 'Татьяна Буланова',
    markerLoadedMessage: 'Маркер добавлен',
    markerFoundMessage: 'Маркер обнаружен',
    markers: [
        {
            title: '',
            videoSrcs: [
                '/assets/bulanova/video/bulanova.mp4',
                '/assets/bulanova/video/bulanova.webm',
                '/assets/bulanova/video/bulanova.ogv',
            ],
            markerSrc: '/assets/bulanova/nft/bulanova1',
        },
    ],
};

export default CONFIG;